module.exports = __webpack_public_path__ + "media/images/map/star-1512039b2fe9999b694bfe8dfe629c52.svg";